import { render, staticRenderFns } from "./ManufacturerSalesByProduct.vue?vue&type=template&id=519212c4&"
import script from "./ManufacturerSalesByProduct.vue?vue&type=script&lang=js&"
export * from "./ManufacturerSalesByProduct.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports